// extracted by mini-css-extract-plugin
module.exports = {"switcherContainer":"left-right-switcher_switcherContainer__1c_B_","switcher":"left-right-switcher_switcher__2As4Z"};